import {until} from 'lit-html/directives/until';
import {generalLabels} from '@modules/i18n-labels';
import {LoadingEllipses} from '@epg/epg-components';

const getQuantity = (ctx, html) => {
  switch (ctx['selection-mode']) {
    case 'all':
      return html`(${ctx['total-results-count'] - ctx['not-selected-count']})`;
    case 'page':
      return html`(${ctx['persistent-selection-count'] - ctx['not-selected-count']})`;
    default:
      return (ctx['persistent-selection-count']) ?
        html`(${ctx['persistent-selection-count']})` :
        ``;
  }
};

export default (ctx, html) => html`
  <button type="button" data-bi-id="${ctx['data-bi-id']}" class="btn btn-primary shadow-sm ${ctx.disabled ? 'disabled' : ''} d-flex justify-content-between" tabindex="-1">
    <div class="font-weight-semibold">
        ${until(generalLabels.bulkActions)}
        ${ctx.loading ? html`<div class="spinner-border" role="status"><span class="sr-only"></span></div>` : getQuantity(ctx, html)}
    </div>
    <div>
      <span class="ai ai-chevron-down"></span>
    </div>
  </button>
`;
